var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#DF9F39"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 15.75H15C14.6022 15.75 14.2206 15.908 13.9393 16.1893C13.658 16.4706 13.5 16.8522 13.5 17.25V18.75H28.5V17.25C28.5 16.8522 28.342 16.4706 28.0607 16.1893C27.7794 15.908 27.3978 15.75 27 15.75ZM13.5 24.75C13.5 25.1478 13.658 25.5294 13.9393 25.8107C14.2206 26.092 14.6022 26.25 15 26.25H27C27.3978 26.25 27.7794 26.092 28.0607 25.8107C28.342 25.5294 28.5 25.1478 28.5 24.75V20.25H13.5V24.75ZM15.75 23.25H18C18.1989 23.25 18.3897 23.329 18.5303 23.4697C18.671 23.6103 18.75 23.8011 18.75 24C18.75 24.1989 18.671 24.3897 18.5303 24.5303C18.3897 24.671 18.1989 24.75 18 24.75H15.75C15.5511 24.75 15.3603 24.671 15.2197 24.5303C15.079 24.3897 15 24.1989 15 24C15 23.8011 15.079 23.6103 15.2197 23.4697C15.3603 23.329 15.5511 23.25 15.75 23.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardPayments);
export default __webpack_public_path__ + "static/media/credit_card_payments.54d249299d6b3963f6287f1920c784e2.svg";
export { ForwardRef as ReactComponent };